import React, { FC } from "react";
import { Navigate } from "react-router-dom";
import { myAccountLink, CommonErrorPopup } from "component-library";
import { getUserGroup, UserGroupAccountTypeMap } from "shared-auth";
import { AccountType, ErrorCode } from "shared-types";
import { useTranslation } from "i18n";

interface IWithAccessControlOptions {
  accountTypes: AccountType[];
  redirect?: () => string;
}

export default function withAccessControl<TProps>(
  options: IWithAccessControlOptions
) {
  return (
    WrappedComponent: React.ComponentType<React.PropsWithChildren<TProps>>
  ): FC<React.PropsWithChildren<TProps>> => {
    const WithAccessControl: FC<React.PropsWithChildren<TProps>> = (props) => {
      const { t } = useTranslation();
      const accountType = UserGroupAccountTypeMap[getUserGroup()];
      const isUserTypeAllowed = options.accountTypes.includes(accountType);

      const onCoseClick = () => window.location.assign(myAccountLink);

      if (!isUserTypeAllowed && options?.redirect)
        return <Navigate to={options.redirect()} replace />;

      if (!isUserTypeAllowed) {
        return (
          <CommonErrorPopup
            errorStatusCode={ErrorCode.Forbidden}
            popupProps={{
              close: onCoseClick,
            }}
            alertMessageProps={{
              buttons: [
                {
                  name: t("common:button.label.close"),
                  type: "primary",
                  click: onCoseClick,
                },
              ],
            }}
          />
        );
      }

      return <WrappedComponent {...props} />;
    };

    return WithAccessControl;
  };
}
